import { assetImages } from "constants";

const AccessDeniedView = () => {
  return (
    <section className="feed_pnltotal">
      <div className="empty_access text-center">
        <div className="empty_pic mb-4">
          {" "}
          <img src={assetImages.emptyVector} alt="" />
        </div>
        <div className="empty_text">
          <p className="fs-lg text-gray fw-semibold mb-4">
            Sorry....! You don't have privilege to see this content
          </p>
        </div>
      </div>
    </section>
  );
};

export default AccessDeniedView;
